import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // @ts-expect-error importing file from js

import { fetchEventList } from 'AdsUI/actions/EventSettingsActions';
import { getFacebookCapiLCSEvents, getNonCapiFacebookLCSEvents } from 'AdsUI/lib/events'; // @ts-expect-error importing file from js

import { Networks } from 'AdsUI/lib/Constants'; // @ts-expect-error importing file from js

import { getEvents } from 'AdsUI/selectors/EventsSelectors'; // @ts-expect-error importing from JS file

import { getRequestStatus } from 'AdsUI/selectors/RequestStatusSelectors';

/**
 * Hook for fetching events and getting all Facebook events and all Facebook
 * CAPI events.
 * @returns All Facebook events (`allFacebookEvents`), Facebook CAPI LCS events (`facebookCapiEvents`), and Facebook LCS events not using CAPI (`nonCapiFacebookLCSEvents`)
 */
const useFacebookEvents = () => {
  const dispatch = useDispatch();
  const eventsRequestStatus = useSelector(getRequestStatus('events'));
  const eventsAsList = useSelector(getEvents);
  const eventsAsJson = eventsAsList.toJS();
  const allFacebookEvents = eventsAsJson.filter(event => event.adNetwork === Networks.FACEBOOK);
  const facebookCapiEvents = getFacebookCapiLCSEvents(eventsAsJson);
  const nonCapiFacebookLCSEvents = getNonCapiFacebookLCSEvents(eventsAsJson);
  useEffect(() => {
    // Deduplicate events fetching
    if (!eventsRequestStatus.fetching && !eventsRequestStatus.fetched) {
      dispatch(fetchEventList());
    }
  }, [eventsRequestStatus.fetching, eventsRequestStatus.fetched, dispatch]);
  return {
    allFacebookEvents,
    facebookCapiEvents,
    nonCapiFacebookLCSEvents
  };
};

export default useFacebookEvents;